export default __webpack_public_path__ + "static/zeus-9cb504f5e6c50cc5ca61e76afe795ba1.svg";